import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './ArtistList.module.css';

const api = axios.create({
  baseURL: 'https://back-cultura-sje-production.up.railway.app',
});

function getPrimeiroESegundoNome(nomeCompleto) {
  if (!nomeCompleto) return '-';

  const partes = nomeCompleto
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (partes.length === 0) return '-';
  if (partes.length === 1) return partes[0];

  return `${partes[0]} ${partes[1]}`;
}

export default function ArtistList() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchArtists() {
      try {
        setLoading(true);
        const response = await api.get('/artists');
        setArtists(response.data.data || []);
      } catch (error) {
        setErro('Não foi possível carregar os artistas.');
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    fetchArtists();
  }, []);

  if (loading) {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>Lista de Artistas</h1>
        <p className={styles.message}>Carregando...</p>
      </div>
    );
  }

  if (erro) {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>Lista de Artistas</h1>
        <p className={styles.error}>{erro}</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Lista de Artistas</h1>

      {artists.length === 0 ? (
        <p className={styles.message}>Nenhum artista cadastrado.</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Linguagem artística</th>
              </tr>
            </thead>
            <tbody>
              {artists.map((artist) => (
                <tr
                  key={artist.id}
                  className={styles.clickableRow}
                  onClick={() => navigate(`/artista/${artist.id}`)}
                >
                  <td>{artist.id}</td>
                  <td>{getPrimeiroESegundoNome(artist.nomeCompleto)}</td>
                  <td>{artist.linguagemArtistica.join(' • ') || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}